import React from "react";
import routes from "../consts/routes.json";
import { logout } from "../services/JwtService";

function UnauthorizedView({ history }) {
    return (
        <div className="viewContent">
            <h1>Zugriff verweigert</h1>
            <div>
                <p>Sie haben nicht die nötige Berechtigung, um die von Ihnen ausgewählte Aktion durchzuführen!</p>
                <p>Sollten Sie mit dem falschen Konto angemeldet sein, melden Sie sich bitte mit dem korrekten Konto an.</p>
                <p>
                    <br />
                </p>
            </div>
            <u
                onClick={() => {
                    logout();
                    history.push(routes.LOGIN);
                }}
            >
                Abmelden und erneut anmelden
            </u>
        </div>
    );
}

export default UnauthorizedView;
